import { FunctionComponent } from 'react';
import {
  WizardCurrentStep,
  WizardStateWrapper,
  WizardStepTree,
  WizardStepTreeSnapshot
} from '../interfaces/wizard-step';
import { WizardHeader } from '../WizardHeader/WizardHeader';
import { WizardStep } from '../WizardStep/WizardStep';
import { WizardFooter } from '../WizardFooter/WizardFooter';
import { useAnalyticsTracker } from '../../tracking/hooks/useAnalyticsTracker';
import { WizardTrackers } from '../trackers/wizard-trackers';

interface WizardProps {
  wizardState: WizardStateWrapper | null;
  currentStep: WizardCurrentStep | null;
  stepGroups: WizardStepTree | null;
  stepTreeSnapshot: WizardStepTreeSnapshot | null;
  currentStepFooterProps: object;
  onCancelClick: VoidFunction;
  onBackClick: VoidFunction;
  selectStepGroup: (stepGroups: WizardStepTree, index: number) => void;
  WizardHeaderLeftComponent?: FunctionComponent;
  wizardHeaderLeftComponentProps?: object;
  trackingProps?: object;
}

export function Wizard({
  wizardState,
  currentStep,
  stepGroups,
  selectStepGroup,
  stepTreeSnapshot,
  currentStepFooterProps,
  onCancelClick,
  onBackClick,
  trackingProps = {},
  WizardHeaderLeftComponent,
  wizardHeaderLeftComponentProps
}: WizardProps) {
  const { eventTrack } = useAnalyticsTracker();

  const setBeforeUnload = (callback: VoidFunction) => {
    // eslint-disable-next-line no-param-reassign
    currentStep!.beforeUnload = callback;
  };

  const renderComponent = !!stepGroups && !!stepTreeSnapshot && !!wizardState && !!currentStep;

  if (!renderComponent) {
    return null;
  }

  return (
    <div className='main-content-area'>
      <WizardHeader
        steps={stepGroups}
        stepTreeSnapshot={stepTreeSnapshot}
        Left={WizardHeaderLeftComponent}
        leftProps={wizardHeaderLeftComponentProps}
        selectStepGroup={index => {
          eventTrack({
            action: WizardTrackers.WIZARD_SELECT_STEP_CLICK,
            properties: {
              step: index,
              ...trackingProps
            }
          });
          selectStepGroup(stepGroups, index);
        }}
      />

      <div className='flex-1 overflow-hidden'>
        <WizardStep
          wizardState={wizardState}
          currentStep={currentStep}
          setCurrentStepBeforeUnload={setBeforeUnload}
        />
      </div>

      <WizardFooter
        stepTreeSnapshot={stepTreeSnapshot}
        back={() => {
          eventTrack({
            action: WizardTrackers.WIZARD_FOOTER_BACK_CLICK,
            properties: {
              ...trackingProps
            }
          });

          onBackClick();
        }}
        close={() => {
          eventTrack({
            action: WizardTrackers.WIZARD_FOOTER_CANCEL_CLICK,
            properties: {
              ...trackingProps
            }
          });

          onCancelClick();
        }}
        ExtraComponent={currentStep?.footerComponent}
        extraComponentProps={currentStepFooterProps}
      />
    </div>
  );
}
